import { useState, useEffect, useCallback } from 'react';
import { leaderboardEvents, LeaderboardEventSummary } from '../api/leaderboard-events';
import { useAlert } from '../contexts/AlertContext';

export const useLeaderboardSummary = (eventId?: number) => {
  const [summary, setSummary] = useState<LeaderboardEventSummary | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const { showAlert } = useAlert();

  const fetchSummary = useCallback(async () => {
    if (!eventId) {
      setSummary(null);
      return;
    }

    try {
      setIsLoading(true);
      const response = await leaderboardEvents.getSummary(eventId);
      setSummary(response);
    } catch (error) {
      console.error('Failed to fetch leaderboard summary:', error);
      showAlert('Failed to fetch leaderboard summary', 'error');
      setSummary(null);
    } finally {
      setIsLoading(false);
    }
  }, [eventId, showAlert]);

  useEffect(() => {
    fetchSummary();
  }, [fetchSummary]);

  return {
    summary,
    isLoading,
    refetch: fetchSummary,
  };
};
